import React from 'react'
import { Unwrapped } from '@jsonforms/material-renderers'
import { withJsonFormsControlProps, withTranslateProps } from '@jsonforms/react'

const { MaterialEnumControl } = Unwrapped

export function CustomMaterialEnumControl(props) {
    // x-pandium-metadata-unsynced: backend sets this when no tenant run has synced metadata yet for this field
    const isUnsynced = props.schema['x-pandium-metadata-unsynced']
    // The enum tester also claims `const` schemas, which offer one value.
    const values = isUnsynced
        ? []
        : props.schema.enum ??
          (props.schema.const !== undefined ? [props.schema.const] : [])
    const options = values.map((option) => ({
        label: option,
        value: option,
    }))

    return (
        <MaterialEnumControl
            {...props}
            enabled={isUnsynced ? false : props.enabled}
            options={options}
        />
    )
}

export default withJsonFormsControlProps(
    withTranslateProps(CustomMaterialEnumControl)
)
